import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import { AdminPanelSettings } from '@mui/icons-material';
import AdminGames from '../components/AdminGames';
import AdminTeams from '../components/AdminTeams';
import AdminUsers from '../components/AdminUsers';
import AdminApi from '../components/AdminApi';

const AdminDashboard = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          <AdminPanelSettings sx={{ mr: 2, verticalAlign: 'middle' }} />
          Admin Dashboard
        </Typography>

        <Paper sx={{ mt: 3 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Games Management" />
            <Tab label="Teams Management" />
            <Tab label="Users Management" />
            <Tab label="API Management" />
          </Tabs>

          <Box sx={{ p: 3 }}>
            {tabValue === 0 && <AdminGames />}
            {tabValue === 1 && <AdminTeams />}
            {tabValue === 2 && <AdminUsers />}
            {tabValue === 3 && <AdminApi />}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AdminDashboard;
